import React from "react"

import { Select } from "antd"
import cls from "classname"
import { useSelector } from "react-redux"

import Icon from "../../Icon"

import "./styles.less"

export const SelectComponent = React.forwardRef(({ className, ...props }, ref) => {
  const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)

  return (
    <Select
      suffixIcon={<Icon type="chevron_down_small" style={{ pointerEvents: "none" }} />}
      menuItemSelectedIcon={<Icon type="circle_check" />}
      ref={ref || null}
      className={cls(className, "select", {
        "disabled-transition": isDisabledTransition
      })}
      {...props}
    />
  )
})

export default SelectComponent
